export default __webpack_public_path__ + "static/media/etherum.9ea19cc9.svg";